import { createFileRoute, redirect } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions } from '@/api/client'
import { KnowledgeScreen } from '@/components/knowledge-base/knowledge-screen'

export const Route = createFileRoute('/_panel/baza-wiedzy')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status !== 200 || (me.data.role !== 'admin' && me.data.role !== 'superadmin')) {
      throw redirect({ to: '/' })
    }
  },
  component: KnowledgeScreen,
})
